import React, { useState } from "react"
import { Navigate } from "react-router-dom"
import getAppConfig from "~/utils/getAppConfig"
import { useToast } from "~/utils/Toast"

import { apiPacks } from "~/routes"

import PageContainer from "~/library/PageContainer"
import PackForm from "~/components/PackForm"

const NewPack = () => {
  const { venueSlug } = getAppConfig()
  const [createdPackId, setCreatedPackId] = useState<string | null>(null)
  const toast = useToast()

  const handleSubmit = (formValues: any) => {
    const data = {
      venue_slug: venueSlug,
      pack: formValues,
    }

    const req = apiPacks.create({ data })
    req
      .then(({ pack }) => {
        setCreatedPackId(pack.id)
        toast("Pack created successfully", "success")
      })
      .catch((res) => {
        toast(
          `Error creating pack. ${res.body?.errors?.join(", ") || "Please try again"}`,
          "danger"
        )
      })
  }

  if (createdPackId) {
    return <Navigate to={`/packs/${createdPackId}`} />
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">New Pack</h3>
          <PackForm onSubmit={handleSubmit} initialValues={{}} />
        </div>
      </div>
    </PageContainer>
  )
}

export default NewPack
